import store from '@/store'

export default [
  {
    path: '/generate-total-scores',
    name: 'generate-total-scores',
    meta: { requiresAuth: true },
    component: () => import('@/pages/generate-total-score/index.vue')
  }
]
